module.exports = __webpack_public_path__ + "img/1.736c8302.png";